import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { NotificationService } from '../../services/notification.service';
import { Observable } from 'rxjs';
import { withLatestFrom } from 'rxjs/operators';

import { DisciplineActionTypes, DisciplineLoad, DisciplineLoadSuccess } from '@completion/actions';
import { State } from '@completion/reducers';
import { getCurrentProject } from '@completion/selectors';
import { Project } from '@completion/models';
import { DisciplineService } from '../../services/discipline.service';
import { trackResource } from './resource-fetch.util';

@Injectable()
export class DisciplineEffect {
  constructor(
    private actions$: Actions,
    private disciplineService: DisciplineService,
    private store: Store<State>,
    private toastr: NotificationService,
  ) {}

  loadDisciplines$ = createEffect(() =>
    this.actions$.pipe(
      ofType<DisciplineLoad>(DisciplineActionTypes.DisciplineLoad),
      withLatestFrom(this.store.select(getCurrentProject) as Observable<Project>),
      trackResource({
        actions$: this.actions$,
        store: this.store,
        toastr: this.toastr,
        service: this.disciplineService,
        method: 'getDisciplines',
        serviceArgs: ([_, currentProject]) => [currentProject.id],
        onSuccess: (response) => new DisciplineLoadSuccess(response as any),
      }),
    ),
  );
}
